import React, { Component } from 'react';
import { withDomains, RESTExecutor } from '../../../lib/domain';


import { Row, Table, Button, Divider, Input, message } from 'antd';
import Title from 'antd/lib/typography/Title';
import { Link } from 'react-router-dom';
import { schema_to_field, formatMoney } from '../../../lib/util';
import { PopUpForm } from '../../../lib/ui/popupform';


const reports_cols = ({
    onAddEditPressed
}) => [
    {
        title: "Report Name",
        dataIndex: "name",
        key: 'name'
    },
    // {
    //     title: "Version",
    //     dataIndex: 'version',
    //     key: 'version'
    // },
    {
        title: "Report ID",
        dataIndex: 'id',
        key: 'id'
    },
    {
        title:"",
        dataIndex:'meta_config',
        key:'action',
        render:(meta_config=[],data)=>{
            return Array.isArray(meta_config)&&meta_config.length>0?<Button onClick={()=>{
                typeof onAddEditPressed==='function'&&onAddEditPressed(meta_config,data)
            }} type='link'>Meta</Button>:<span></span>
        }
    }
]

class ReportPluginView extends Component {
    constructor(props) {
        super(props)

        this.state = {
            meta_form_visibility: false,
            selected_report:{},
            form_data:{},
            form_schema:[]
        };
        this.list_reports_plugin = RESTExecutor.list().config({
            label: 'report_plugins',
        }).connect(props.domains.settings);

        this.post_meta=RESTExecutor.post().config({
            label:'report_plugin_detail'
        }).callbacks((success)=>{
            message.success("Meta Updated");
            this.list_reports_plugin.execute();
            this.setState({
                meta_form_visibility: false,
                selected_report:{},
                form_data:{},
                form_schema:[]
            })
        }).connect(props.domains.plugins)


        console.log("constructed")
    };


    render() {

        let list_reports_plugin_res = this.list_reports_plugin.response();
        let list_reports_plugin_data = list_reports_plugin_res.result || {};
 
        let post_meta_resp=this.post_meta.response();

        let rowsMeta=list_reports_plugin_res.meta||{};
        let rowsData = list_reports_plugin_data.rows || [];

        let filteredData=JSON.parse(JSON.stringify(rowsData));
        if(this.state.query){
            filteredData=filteredData.filter(({ name="",id="",description="" }) => {
                name = name.toLowerCase();
                id=id.toLowerCase();
                description=description.toLowerCase();
                return name.includes(this.state.query.toLowerCase())
                ||id.includes(this.state.query.toLowerCase())
                ||description.includes(this.state.query.toLowerCase())
                ;
            });
        }
        return (
            <div>
                    <PopUpForm
                        title={`Meta for ${this.state.selected_report.name}`}
                        forCreate={Object.keys(this.state.form_data).length>0?false:true}
                        initialData={this.state.form_data}
                        width='80%'
                        fields={this.state.form_schema}
                        open={this.state.meta_form_visibility}
                        networkState={post_meta_resp}
                        onClose={() => this.setState({meta_form_visibility: false})}
                        onSubmit={(data) => {
                        console.log("DATA", data);
                        this.post_meta.forId(this.state.selected_report.id).execute({meta:data});
                        // this.handlePostPatch(data);
                    }}/>

                <Table
                scroll={{x:true}}
                loading={list_reports_plugin_res.fetching}
                    columns={reports_cols({
                        onAddEditPressed:(meta_config,data)=>{
                            this.setState({
                                form_schema:schema_to_field(meta_config),
                                form_data:data.meta||{},
                                meta_form_visibility:true,
                                selected_report:data
                            });

                        }
                    })}
                    pagination={{
                    showTotal:(total,range)=>`${formatMoney(range[0],0)}-${formatMoney(range[1],0)} of ${formatMoney(total,0)} items`
                    }}
                    dataSource={filteredData}
                    className='main-table'                    size='small'
                    title={() => <div><Row type='flex' justify='space-between' style={{
                        alignItems: 'center'
                    }}><Title
                        type='secondary'
                        level={3}

                        style={{
                            margin: 0
                        }}>Report List</Title>
                       
                    </Row><br></br>
                    <Row type='flex'
                    justify='space-between'
                    style={{
                    alignItems: 'center',
                    flexWrap: 'nowrap'
                }}>
                        <Input.Search
                            placeholder="Search For"
                            style={{
                        }} autoFocus
                            value={this.state.query}
                            onChange={(e) => {
                                this.setState({query:e.target.value})
                            }}
                           /> {this.state.query && this.state.query.length > 0 && <Button
                            style={{
                            marginLeft: 4
                        }}
                            type='danger'
                            shape="circle"
                            icon="close-circle"
                            onClick={() => {
                            this.setState({query:null})
                        }}/>}
                    </Row></div>}
                    rowKey={(record) => record.id}
                />
            </div>
        )
    }

    componentDidMount() {
        this.list_reports_plugin.execute()
    }
}

export default withDomains(ReportPluginView,"settings","plugins");



